let editDistance = (a: string, b: string): number =>
  a.split('').reduce(
    (prevRow, aChar, i) =>
      b
        .split('')
        .reduce(
          (acc, bChar, j) => [
            ...acc,
            aChar === bChar
              ? prevRow[j]
              : 1 + Math.min(prevRow[j], prevRow[j + 1], acc[acc.length - 1]),
          ],
          [i + 1] as number[],
        ),
    Array.from({ length: b.length + 1 }, (_, j) => j),
  )[b.length]

export let isFuzzyMatch = (name: string, query: string): boolean => {
  let n = name.toLowerCase()
  let q = query.toLowerCase()
  let threshold = Math.floor(q.length / 4) + 1
  return (
    n.includes(q) ||
    editDistance(n, q) <= threshold ||
    n.split(' ').some((word) => editDistance(word, q) <= 1)
  )
}
